export const environment = {
  production: false,
  consultaRecallEndpoint: "https://apimazqa.grupokaufmann.com/qas/erp/servicio/vehiculos/v1/recall",
  consultaVehiculoEndpoint: 'https://apimazqa.grupokaufmann.com/qas/erp/cliente/v1/movilidad/Retorna_unidadesSet',
  apiKey: 'd0124900e1b847a18404ec7b2a71c46d',
};
